import request from '@/utils/request';

export const getAreaUser = () =>
  request({
    url: '/api/v1/omc/statistic/area/user',
  });
